import {MutationTree} from "vuex";
import {SmsFiltersState} from "@/store/sms/filters/types";

export const mutations: MutationTree<SmsFiltersState> = {
  setSmsFilters: (state, payload) => {
    state.smsFilters = payload
  },
  setSmsFilterItem: (state, payload) => {
    state.smsFilterItem = payload
  }
}